// src/components/Footer.jsx

import React from 'react';
import { Box, Container, Stack, Typography, Link as MUILink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <Box component="footer" sx={{ mt: 6, borderTop: 1, borderColor: 'divider', py: 3, bgcolor: 'background.paper' }}>
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={2}
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          justifyContent="space-between"
        >
          <Typography variant="body2" color="text.secondary">
            © {year} Meetin. All rights reserved.
          </Typography>

          <Stack direction="row" spacing={2}>
            <MUILink component={RouterLink} to="/privacy" underline="hover" color="text.secondary" variant="body2">
              Privacy
            </MUILink>
            <MUILink component={RouterLink} to="/terms" underline="hover" color="text.secondary" variant="body2">
              Terms
            </MUILink>
            <MUILink component={RouterLink} to="/contact" underline="hover" color="text.secondary" variant="body2">
              Contact
            </MUILink>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}


